import { request, fileUpload } from './request';

export const getAllTreatments = (page = 1, filterString = '', limit = 50) =>
  request(`treatments?page=${page}${filterString}&limit=${limit}`);

export const getTreatmentById = (id) => request(`treatments/${id}`);

export const updateTreatment = (id, body) =>
  request(`treatments/${id}`, {
    method: 'PATCH',
    body,
  });

export const createTreatment = (body) =>
  request(`treatments`, {
    method: 'POST',
    body,
  });

export const uploadFiles = (
  id,
  files,
  type,
  isShared,
  path,
  onUploadProgress,
) => {
  return fileUpload(`${path}/${id}`, files, type, isShared, onUploadProgress);
};
